import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export const professionalQualificationsApi = {
  getAll: () =>
    api.get<ApiResponse<any[]>>('/professional-qualifications'),

  getActive: () =>
    api.get<ApiResponse<any[]>>('/professional-qualifications/active'),

  getById: (id: number) =>
    api.get<ApiResponse<any>>(`/professional-qualifications/${id}`),

  create: (data: { name: string, is_active?: boolean }) =>
    api.post<ApiResponse<any>>('/professional-qualifications', data),

  update: (id: number, data: { name: string, is_active?: boolean }) =>
    api.put<ApiResponse<any>>(`/professional-qualifications/${id}`, data),

  delete: (id: number) =>
    api.delete<ApiResponse>(`/professional-qualifications/${id}`),

  hardDelete: (id: number) =>
    api.delete<ApiResponse>(`/professional-qualifications/${id}/permanent`),
}
